var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "M19 28L13 28 13 10.039 13 7.006 14 6.006 18 6.006 19 7.006 19 10.039z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe0b2",
    d: "M8 35H40V40H8zM8 28H40V33H8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M40.5 22L40.5 22c.828 0 1.5.672 1.5 1.5V40h-3V23.5C39 22.672 39.672 22 40.5 22zM7.5 22L7.5 22C8.328 22 9 22.672 9 23.5V40H6V23.5C6 22.672 6.672 22 7.5 22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffcc80",
    d: "M8 33H40V35H8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M24,15H10c-1.105,0-2-0.895-2-2v-2.994c0-1.105,0.895-2,2-2h10.744c0.22,0,0.434,0.072,0.608,0.206l3.256,2.494C24.855,10.895,25,11.189,25,11.5V14C25,14.552,24.552,15,24,15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M35,19c0,0,5-2,5-6c0-3-3-6-4-6v6c0,0-1,1-2.5,1S31,13,31,13V7c-1,0-4,3-4,6c0,4,5,6,5,6l-1,9h2.5H36L35,19z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiy);
export default __webpack_public_path__ + "static/media/diy.bc3f6cb469b9f8fbe020b66897fb6fcb.svg";
export { ForwardRef as ReactComponent };